import * as React from "react";
import { Dropdown, IDropdownOption, IDropdownStyles, ResponsiveMode } from "@fluentui/react";
import { IMultipleSelectionInput } from "../../../../../interfaces/advancedSearch/IMultipleSelectionInput";
import { LanguageContext } from "../../../../../../../utilities/LocalizationModule";

export const ChoicePicker: React.FunctionComponent<IMultipleSelectionInput> = props => {
  const languageStrings = React.useContext(LanguageContext);
  const [options] = React.useState<IDropdownOption[]>([{ key: null, text: "" }, ...props.choices.map(item => ({ key: item, text: item }))]);
  const handleOnChange = (event: React.FormEvent<HTMLDivElement>, item: IDropdownOption): void => {
    props.handleValueChange(props.searchInputData?.index, item.key);
  };

  const dropdownStyles: Partial<IDropdownStyles> = { root: { width: "100%" } };
  return (
    <Dropdown
      label={props.displayName}
      placeholder={languageStrings.SelectOption}
      onChange={handleOnChange}
      selectedKey={props.searchInputData ? props.searchInputData?.value : undefined}
      options={options}
      className="xb-sp-input"
      // responsiveMode={ResponsiveMode.small}
      styles={dropdownStyles}
    />
  );
};

export default ChoicePicker;
